import React from 'react';
import { FiMonitor, FiShield, FiBarChart2, FiUsers } from 'react-icons/fi';
import './Features.css';

const features = [
  {
    icon: <FiMonitor size={50} />,
    title: 'Enable Hybrid',
    desc: 'Power hot desking and meeting room booking solutions mapped to your workplace and rules.',
  },
  {
    icon: <FiShield size={50} />,
    title: 'Experience Contactless Access',
    desc: 'Welcome employees to a safer office environment with touchless access control.',
  },
  {
    icon: <FiBarChart2 size={50} />,
    title: 'Efficient Space Utilization',
    desc: 'Our scheduling and analytics help you get the data required for you to make the decisions that matter.',
  },
  {
    icon: <FiUsers size={50} />,
    title: 'Empower employees',
    desc: 'Reduce Administrative overheads and empower your employees to high value opportunity through our tech.',
  },
];

function Features() {
  return (
    <section className="features">
      <div className="container">
        <h2 className="section-title">
          The integrated workplace management platform built around productivity
        </h2>
        <div className="features-grid">
          {features.map((f, i) => (
            <div key={i} className="feature-card">
              <div className="feature-icon">{f.icon}</div>
              <h3>{f.title}</h3>
              <p>{f.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Features;
